module.exports = __webpack_public_path__ + "static/media/Rainbow_SEO.3fc05052.png";